import React, { useEffect } from "react";
import { WidgetProps } from "@rjsf/utils";
import { Switch } from "antd";

const ToggleWidget = (props: WidgetProps) => {
    const {
        id,
        value = false,
        disabled,
        readonly,
        onChange,
    } = props;

    // set value to false if undefined or null
    useEffect(() => {
        if (value === undefined || value === null) {
            onChange(false);
        }
    }, [value, onChange]);

    const handleChange = (checked: boolean) => {
        onChange(checked);
    };

    return (
        <Switch
            rootClassName="hnn-switch"
            id={id}
            checked={value || false}
            disabled={disabled || readonly}
            onChange={handleChange}
        />
    );
};

export default ToggleWidget;
